import { apiClient } from './api'

export async function generatePresignedUrl(objKey){
  const {data} = await apiClient.get(`/api/resource/${objKey}`)
  return data
}
